// extracted by mini-css-extract-plugin
export default {"panel":"NotesSidePanel_panel__ki8zI","header":"NotesSidePanel_header__Y85d7","list":"NotesSidePanel_list__0HOEw"};